module.exports = __webpack_public_path__ + "static/img/jinglingniao.59ec245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/woman/banner/jinglingniao.jpg
// module id = Hwvg
// module chunks = 0